import React from 'react';

import type * as api from '@gitbook/api-client';
import { ActionableContainerSkeleton, Alert } from '@gitbook/spine-react';
import { ErrorBoundary } from '@gitbook/util-debug';

import { useContactSupport } from '../../../../state';
import { IntegrationConfigureSiteFlowById, IntegrationStepWrapper } from '../../../Integrations';
import type { SetupFeatureFlagsStepProps } from '../../types';

/**
 * Step to configure the feature flags provider integration.
 */
export function ConfigureIntegrationStep(
    props: SetupFeatureFlagsStepProps & { integration: api.Integration }
) {
    const { organizationId, siteId, onNext, integration } = props;
    const contactSupport = useContactSupport();

    return (
        <IntegrationStepWrapper
            title="Site configuration"
            description="Configure the feature flags provider integration for this site"
        >
            <ErrorBoundary
                fallback={
                    <Alert
                        kind="danger"
                        title="Error while loading the integration"
                        details="Something went wrong while loading the integration configuration component. This is unusual, please get in touch with our support."
                        action={{
                            label: 'Contact support',
                            onPress: () => {
                                contactSupport({
                                    message: '',
                                });
                            },
                        }}
                    />
                }
            >
                <React.Suspense fallback={<ActionableContainerSkeleton />}>
                    <IntegrationConfigureSiteFlowById
                        integrationName={integration.name}
                        organizationId={organizationId}
                        siteId={siteId}
                        onComplete={() => {
                            onNext(integration);
                        }}
                    />
                </React.Suspense>
            </ErrorBoundary>
        </IntegrationStepWrapper>
    );
}
